import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';
import {currentResource} from '../../util/utils';

export function contentupdatesReducer(state = initialstate.contentupdates, action) {
    switch (action.type) {
        case types.GET_CONTENT_UPDATE_HISTORY:
            if (action.response) {
                return action.response || state;
            }
            break;
        default:
            return state;
    }
}

export function pspAccountsReducer(state = initialstate.engagementPspAccounts, action) {
    switch (action.type) {
        case types.GET_PSP_ACCOUNTS:
            if (action.response) {
                return action.response ;
                }
        default:
            return state;
    }
}

let mockPspAccounts = {
    accounts: [
        {
            accountId: 1,
            accountName: 'acc-test',
            createDate: new Date(2000, 3, 14),
            status: "Update in progress",
            statusId: 1
        },
        {
            accountId: 2,
            accountName: 'Account1',
            createDate: new Date(2023, 12, 15),
            status: "",
            statusId: 2 //
        },
        {
            accountId: 3,
            accountName: 'romm',
            createDate: new Date(2022, 8, 22),
            status: "",
            statusId: 2
        },
        {
            accountId: 4,
            accountName: 'test period balance',
            createDate: new Date(2011, 5, 26),
            status: "Error",
            statusId: 3
        },
        {
            accountId: 5,
            accountName: 'test romm type',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        },
        {
            accountId: 6,
            accountName: 'acc-test',
            createDate: new Date(2000, 3, 14),
            status: "",
            statusId: 2
        },
        {
            accountId: 7,
            accountName: 'Account1',
            createDate: new Date(2023, 12, 15),
            status: "",
            statusId: 2 //
        },
        {
            accountId: 8,
            accountName: 'romm',
            createDate: new Date(2022, 8, 22),
            status: "",
            statusId: 2
        },
        {
            accountId: 9,
            accountName: 'test period balance',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        },
        {
            accountId: 10,
            accountName: 'test romm type',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        },
        {
            accountId: 11,
            accountName: 'acc-test',
            createDate: new Date(2000, 3, 14),
            status: "",
            statusId: 2
        },
        {
            accountId: 12,
            accountName: 'Account1',
            createDate: new Date(2023, 12, 15),
            status: "",
            statusId: 2 //
        },
        {
            accountId: 13,
            accountName: 'romm',
            createDate: new Date(2022, 8, 22),
            status: "Update in progress",
            statusId: 1
        },
        {
            accountId: 14,
            accountName: 'test period balance',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        },
        {
            accountId: 15,
            accountName: 'test romm type',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        },
        {
            accountId: 16,
            accountName: 'acc-test',
            createDate: new Date(2000, 3, 14),
            status: "",
            statusId: 2
        },
        {
            accountId: 17,
            accountName: 'Account1',
            createDate: new Date(2023, 12, 15),
            status: "",
            statusId: 2 //
        },
        {
            accountId: 18,
            accountName: 'romm',
            createDate: new Date(2022, 8, 22),
            status: "",
            statusId: 2
        },
        {
            accountId: 19,
            accountName: 'test period balance',
            createDate: new Date(2011, 5, 26),
            status: "Error",
            statusId: 3
        },
        {
            accountId: 20,
            accountName: 'test romm type',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        },
        {
            accountId: 21,
            accountName: 'acc-test page 2',
            createDate: new Date(2000, 3, 14),
            status: "",
            statusId: 2
        },
        {
            accountId: 22,
            accountName: 'Account1 page 2',
            createDate: new Date(2023, 12, 15),
            status: "",
            statusId: 2 //
        },
        {
            accountId: 23,
            accountName: 'romm page 2',
            createDate: new Date(2022, 8, 22),
            status: "",
            statusId: 2
        },
        {
            accountId: 24,
            accountName: 'test period balance page 2',
            createDate: new Date(2011, 5, 26),
            status: "Update in progress",
            statusId: 1
        },
        {
            accountId: 25,
            accountName: 'test romm type page 2',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        },
        {
            accountId: 26,
            accountName: 'acc-test',
            createDate: new Date(2000, 3, 14),
            status: "",
            statusId: 2
        },
        {
            accountId: 27,
            accountName: 'Account1',
            createDate: new Date(2023, 12, 15),
            status: "",
            statusId: 2 //
        },
        {
            accountId: 28,
            accountName: 'romm',
            createDate: new Date(2022, 8, 22),
            status: "",
            statusId: 2
        },
        {
            accountId: 29,
            accountName: 'test period balance',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        },
        {
            accountId: 30,
            accountName: 'test romm type',
            createDate: new Date(2011, 5, 26),
            status: "Update in progress",
            statusId: 1
        },
        {
            accountId: 31,
            accountName: 'acc-test',
            createDate: new Date(2000, 3, 14),
            status: "",
            statusId: 2
        },
        {
            accountId: 32,
            accountName: 'Account1',
            createDate: new Date(2023, 12, 15),
            status: "",
            statusId: 2 //
        },
        {
            accountId: 33,
            accountName: 'romm',
            createDate: new Date(2022, 8, 22),
            status: "",
            statusId: 2
        },
        {
            accountId: 34,
            accountName: 'test period balance',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        },
        {
            accountId: 35,
            accountName: 'test romm type',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        },
        {
            accountId: 36,
            accountName: 'acc-test',
            createDate: new Date(2000, 3, 14),
            status: "",
            statusId: 2
        },
        {
            accountId: 37,
            accountName: 'Account1',
            createDate: new Date(2023, 12, 15),
            status: "Error",
            statusId: 3 //
        },
        {
            accountId: 38,
            accountName: 'romm',
            createDate: new Date(2022, 8, 22),
            status: "",
            statusId: 2
        },
        {
            accountId: 39,
            accountName: 'test period balance',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        },
        {
            accountId: 40,
            accountName: 'test romm type',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        },
        {
            accountId: 41,
            accountName: 'acc-test page 3',
            createDate: new Date(2000, 3, 14),
            status: "",
            statusId: 2
        },
        {
            accountId: 42,
            accountName: 'Account1 page 3',
            createDate: new Date(2023, 12, 15),
            status: "",
            statusId: 2 //
        },
        {
            accountId: 43,
            accountName: 'romm page 3',
            createDate: new Date(2022, 8, 22),
            status: "",
            statusId: 2
        },
        {
            accountId: 44,
            accountName: 'test period balance page 3',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        },
        {
            accountId: 45,
            accountName: 'test romm type page 3',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        },
        {
            accountId: 46,
            accountName: 'acc-test page 3',
            createDate: new Date(2000, 3, 14),
            status: "",
            statusId: 2
        },
        {
            accountId: 47,
            accountName: 'Account1',
            createDate: new Date(2023, 12, 15),
            status: "Update in progress",
            statusId: 1 //
        },
        {
            accountId: 48,
            accountName: 'romm',
            createDate: new Date(2022, 8, 22),
            status: "",
            statusId: 2
        },
        {
            accountId: 49,
            accountName: 'test period balance',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        },
        {
            accountId: 50,
            accountName: 'test romm type',
            createDate: new Date(2011, 5, 26),
            status: "",
            statusId: 2
        }
    ]
}

export function syncContentUpdatesReducer(state = initialstate.syncContentUpdates, action) {
    switch (action.type) {
        case types.UPDATE_SELECTED_CONTENT:
            if (action.response) {
                return action.response ;
            }
            break;
        default:
            return state;
    }
}